module.exports = ".file-picker {\n  margin: 30px;\n}\n.report {\n  display: flex;\n  align-items: center;\n}\n.report > * {\n  width: 80%;\n}\n"